const header = {
  homepage: '/',
  title: 'SRL.',
}

const about = {
  name: 'Sebastian Rojo',
  role: 'Front End Engineer',
  description:
    "Software developer with +10 years of experience. Specializing in modern web interfaces, I work as a freelancer and Web UI Developer on projects internationally.",
  resume: null,
  social: {
    linkedin: 'https://linkedin.com/in/sebastian-rojo/',
    github: 'https://github.com/sebasrl95',
  },
}

const projects = [
  {
    name: 'Project 1',
    description:
      'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'https://github.com',
  },
  {
    name: 'Project 2',
    description:
      'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'https://github.com',
  },
  {
    name: 'Project 3',
    description:
      'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'https://github.com',
  },
]

const skills = [
  'HTML',
  'CSS',
  'JavaScript',
  'TypeScript',
  'React',
  'Angular',
  'Sass',
  'Material UI',
  'GIT',
  'CI/CD',
  'AWS'
]

const contact = {
  email: 'sebasrojo95@gmail.com',
}

export { header, about, projects, skills, contact }
